import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { initBrowserTracing } from '@interconnect/otel-web'

initBrowserTracing({
  serviceName: 'payment',
  collectorUrl: '/v1/traces',
})

// Runtime config comes from the server (/config.json: ConfigMap in k8s, .env in
// dev) rather than being baked into the bundle at build time. Fetch it, publish
// it on window.__APP_CONFIG__, then import the app — app-context reads the
// config at module load, so the app must not be imported until it is set.
async function bootstrap(): Promise<void> {
  try {
    const res = await fetch('/config.json')
    if (res.ok) {
      ;(
        window as unknown as { __APP_CONFIG__?: unknown }
      ).__APP_CONFIG__ = await res.json()
    } else {
      console.error('failed to load /config.json:', res.status)
    }
  } catch (err) {
    console.error('failed to load /config.json:', err)
  }

  const { default: App } = await import('./RoutedApp')
  ReactDOM.render(<App />, document.getElementById('root'))
}

void bootstrap()
